import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import PageWrapper from "../../shared/PageWrapper";
import DevelopmentNewsList from "./DevelopmentNewsList";

const DevelopmentNewsPage: React.FC = () => {
  return (
    <CPLAnalytics pageName="Development News">
      <PageWrapper title="Development News" data-test-id="development-news-list__back-button">
        <DevelopmentNewsList />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default DevelopmentNewsPage;
